import { useTranslation } from 'react-i18next';

import VerifyingLoader from '~/components/Loaders/VerifyingLoader';

export const VerifyPayment = () => {
	const { t } = useTranslation(['label']);
	return (
		<>
			<div className="flex items-center justify-center mb-6 plus-tools-modal">
				<VerifyingLoader />
			</div>
			<div className="flex flex-col space-y-4">
				<p className="text-base text-content-default text-center">
					{t('CX_AUTH_VERIFYING_PAYMENT')}
				</p>
			</div>
		</>
	);
};

VerifyPayment.displayName = 'VerifyPayment';
